import { Award } from "lucide-react";

export const FoundingBadge = ({ className = "" }) => (
    <span data-testid="founding-badge"
        className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-widest bg-gradient-to-r from-amber-200 to-yellow-300 text-amber-900 border border-amber-400/70 shadow-sm ${className}`}>
        <Award size={11} /> Founding pin
    </span>
);
